import React, { useEffect } from 'react';
import AdminEditBookTemplate from '../../04_templates/AdminEditBookTemplate/AdminEditBookTemplate';

function AdminEditBookPage() {
  useEffect(() => {
    document.title = 'Sweet Bibi - Bewerk Boek';
  }, []);

  return (
    <main>
      <AdminEditBookTemplate />
    </main>
  );
}

export default AdminEditBookPage;
